module.exports = __webpack_public_path__ + "img/about-bg.2eaa3619.png";